const topMainBg = (() => {
  if (document.querySelector("body#pageTop") !== null) {



    let secMain = document.querySelector('#jsSecMain');
    let bgWrap = secMain.querySelector('.js-bg-wrap');
    let bgBox = bgWrap.querySelector('.js-bg-box');
    let bg = bgWrap.querySelector('.js-bg');


    {
      const getGap = () => {
        let bgWrapH = bgWrap.clientHeight;
        let bgH = bg.clientHeight;
        let gap = bgH - bgWrapH
        return gap
      }

      let to1 = gsap.to(bgBox, {
        ease: "none",
        scrollTrigger: {
          trigger: bgBox,
          start: '100% 100%',
          endTrigger: bgWrap,
          end: '100% 0%',
          pin: true,
          // markers: true
        }
      })

      let to2 = gsap.to(bg, {
        y: getGap(),
        ease: "none",
        scrollTrigger: {
          trigger: bgWrap,
          start: '0% 0%',
          end: '100% 100%',
          scrub: true,
          // markers: true
        }
      })


      let target = document.querySelector('body');
      let observer = new ResizeObserver((entries) => {
        entries.forEach((entry) => {
          to1.scrollTrigger.refresh()
          to2.scrollTrigger.refresh()
          // console.log('comParallax refresh');
        });
      });
      observer.observe(target);
    }


  }
})()
export default topMainBg;